export default __webpack_public_path__ + "static/media/BassamAwad.6a31e93f.png";